const $ = require('jquery');

const {Offcanvas} = require("bootstrap");


const clearSearch = () => {
    $(".navbar .results").html("");
    $(".mobile-menu-root .results").html("");
}

const showLoading = () => {
    // Desktop version
    $(".navbar .search .results")
        .html("")
        .removeClass("d-none")
        .append(
            `<div class="loading">Loading...</div>`
        );

    // Mobile version
    $(".mobile-menu-root .search .results")
        .html("")
        .removeClass("d-none")
        .append(
            `<div class="loading">Loading...</div>`
        );
}

const showSearchResults = (results) => {
    const searchHtml = mapSearchResult(results);

    // Desktop version
    $(".navbar .search .results").append(searchHtml);

    // Mobile version
    $(".mobile-menu-root .search .results").append(searchHtml);
}

const mapSearchResult = (results) => {
    let searchHtml = "";

    if (results.franchises.length > 0) {
        searchHtml += `<label>Franchises</label><ul>`;
        for (let index = 0; index < results.franchises.length; index++) {
            const element = results.franchises[index];
            searchHtml += `<li><a href="${element.link}">${element.title}</a></li>`;
        }
        searchHtml += `</ul>`;
    }
    if (results.business.length > 0) {
        searchHtml += `<label>Business</label><ul>`;
        for (let index = 0; index < results.business.length; index++) {
            const element = results.business[index];
            searchHtml += `<li><a href="${element.link}">${element.title}</a></li>`;
        }
        searchHtml += `</ul>`;
    }
    if (results.sba_lender.length > 0) {
        searchHtml += `<label>SBA lander</label><ul>`;
        for (let index = 0; index < results.sba_lender.length; index++) {
            const element = results.sba_lender[index];
            searchHtml += `<li><a href="${element.link}">${element.title}</a></li>`;
        }
        searchHtml += `</ul>`;
    }
    if (results.post.length > 0) {
        searchHtml += `<label>Blogs</label><ul>`;
        for (let index = 0; index < results.post.length; index++) {
            const element = results.post[index];
            searchHtml += `<li><a href="${element.link}">${element.title}</a></li>`;
        }
        searchHtml += `</ul>`;
    }
    if (!searchHtml) {
        searchHtml += `<label>No results...</label>`;
    }

    return searchHtml;
}

const initHeaderSearch = () => {
    // Flag for the debounce mechanism (this allows us to "cancel" the search between keystrokes)
    let timeout;
    // This is the last search term that was sent to the server, we use it to avoid showing outdated results (see below)
    let lastSearch = "";

    const startSearch = (term = "") => {
        vf.services.search(term)
            .then((result) => {
                // If the search term has changed, we don't want to show the results, because they are outdated
                // This race condition can happen when the user waits more than one second between keystrokes
                // Yep.
                if (lastSearch !== term) {
                    return;
                }
                clearSearch();
                showSearchResults(result);
            });
    };

    $(document)
        // Search behavior (both desktop and mobile)
        // We use the function expression because we need to use the "this" keyword
        .on("input", ".search_custom_post", function () {
            const search = lastSearch = this.value;

            // This is just a debounce mechanism
            clearTimeout(timeout);

            timeout = setTimeout(() => {
                startSearch(search);
            }, 1000);

            showLoading();
        })
};

$(() => {
    const offcanvas = new Offcanvas(
        $('#mobileMenuModal')
    );

    $('#openMobileMenu').click(() => {
        offcanvas.toggle();
    })

    $('#mobileSearchBarInput').focus(function (event) {
        $('#accordionPanelsStayOpen').css('display', 'none');
        $('#offcanvasRightLabel').css('display', 'none');
        $('#mobileMenuHeader').css('justify-content', 'flex-end');
    });

    $('#mobileSearchBarInput').focusout(function (event) {
        if ($(this).val().trim() === "") {
            $('#accordionPanelsStayOpen').css('display', 'block');
            $('#offcanvasRightLabel').css('display', 'block');
            $('#mobileMenuHeader').css('justify-content', 'space-between');
            $("#mobileMenu .mobile-search-bar .results").html("").addClass("d-none");
        }
    })
    initHeaderSearch();
});